import { polygon } from "leaflet";
import { getPath, getInitialState, flattenObj } from "../../utils";

const initialState = {
  polygonList: [],
  polygonTypes: [],
  prevPage: -1,
  nextPage: -1,
  currentPage: 1,
  activePolygon: {},
  activeFilters: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_POLYGON_LIST":
      return setPolygonList(state, action);
    case "SET_ACTIVE_POLYGON":
      return setActivePolygon(state, action);
    case "SET_CURRENT_PAGE_POLYGON":
      return setCurrentPagePolygon(state, action);
    case "SET_ACTIVE_POLYGON_FILTERS":
      return setActivePolygonFilters(state, action);
    case "RESET_STATE_POLYGON":
      return resetState(state, action);
    case "SET_POLYGON_TYPES":
      return setPolygonTypes(state, action);
    default:
      return state;
  }
}

const setPolygonTypes = (state, action) => {
  return {
    ...state,
    polygonTypes: action.payload,
  };
}

const setActivePolygon = (state, action) => {
  return {
    ...state,
    activePolygon: flattenObj(action.payload),
  };
};

const setPolygonList = (state, action) => {
  return {
    ...state,
    polygonList: getPath(action.payload, "polygons", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const setCurrentPagePolygon = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setActivePolygonFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
